import { FacebookShareButton, LinkedinShareButton } from 'react-share';

import { observer } from 'mobx-react-lite';

import { IconEmail } from '@components/icons/email';
import { IconFacebook } from '@components/icons/facebook';
import { IconLinkedin } from '@components/icons/linkedin';
import { Stack } from '@components/stack';

import { SocialShareButton } from './styles';

export const SocialShareButtons = observer(({ url }) => {
  return (
    <Stack space={2} orientation="horizontal" justify="flex-start">
      <FacebookShareButton url={url}>
        <SocialShareButton onHoverColor="blueFb200" backgroundColor="blueFb100">
          <IconFacebook invert />
        </SocialShareButton>
      </FacebookShareButton>
      <LinkedinShareButton url={url}>
        <SocialShareButton onHoverColor="blueLi200" backgroundColor="blueLi100">
          <IconLinkedin invert />
        </SocialShareButton>
      </LinkedinShareButton>
      <a href={`mailto:?subject=&body=Hey!%0DPlease check out our career site for job ads: ${url}`}>
        <SocialShareButton onHoverColor="purple200" backgroundColor="purple100">
          <IconEmail />
        </SocialShareButton>
      </a>
    </Stack>
  );
});
